import { Stack } from '@mui/material';
import { Outlet } from 'react-router-dom';

export function ClientOwnershipPage() {
  return (
    <Stack height="100%">
      <Stack flex={1}>
        <Outlet />
      </Stack>
    </Stack>
  );
}
